import { render, staticRenderFns } from "./DataSeriesBars.vue?vue&type=template&id=2d22bdc7&scoped=true&"
import script from "./DataSeriesBars.vue?vue&type=script&lang=ts&"
export * from "./DataSeriesBars.vue?vue&type=script&lang=ts&"
import style0 from "./DataSeriesBars.vue?vue&type=style&index=0&id=2d22bdc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d22bdc7",
  null
  
)

export default component.exports